import { render, staticRenderFns } from "./PriceApp.vue?vue&type=template&id=d4568a9a&scoped=true"
import script from "./PriceApp.vue?vue&type=script&lang=js"
export * from "./PriceApp.vue?vue&type=script&lang=js"
import style0 from "./PriceApp.vue?vue&type=style&index=0&id=d4568a9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4568a9a",
  null
  
)

export default component.exports